import { useLayoutEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import classNames from 'classnames'

import { EMPTY_STRING } from '../../constants/common'
import { QA_MODAL_KEY } from '../../constants/qa'

import { MODAL_OPEN_ATTRIBUTE } from './Modal.constants'

import * as styles from './Modal.module.css'

function Modal({
  children,
  className = styles.Modal,
  hidden = false,
  id,
  isTransparent,
  qaName,
  onClick,
  onClose,
}) {
  // TODO Get rid of `onClick` made for set input inactive

  const [modal, setModal] = useState(null)

  useLayoutEffect(() => {
    const wrapperElement = document.createElement('div')
    const parent = document.getElementById('theme-provider')

    parent.appendChild(wrapperElement)

    // eslint-disable-next-line react-hooks/set-state-in-effect -- the portal container is created on mount and stored once
    setModal(wrapperElement)

    return () => {
      wrapperElement.remove()
    }
  }, [])

  const maskClassName = classNames(styles.mask, {
    [styles.transparent]: isTransparent,
  })

  const rootClassName = classNames(className, {
    [styles.hidden]: hidden,
  })

  const modalQaName = qaName || children?.props?.qaName

  const qaProps = {
    ...(modalQaName ? { [QA_MODAL_KEY]: `${modalQaName}Modal` } : null),
  }

  const openProps = hidden ? null : { [MODAL_OPEN_ATTRIBUTE]: EMPTY_STRING }

  return modal
    ? createPortal(
        <div
          {...qaProps}
          {...openProps}
          className={rootClassName}
          id={id}
          onClick={onClick}
        >
          <div className={maskClassName} onClick={onClose} />
          {children}
        </div>,
        modal
      )
    : null
}

export default Modal
